import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Camera icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Camera } from '@sravni/design-system-icons'
 *
 * <Camera />
 * ```
 */
var Camera = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Camera", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.857 15a1.429 1.429 0 0 1-1.428 1.429H3.57A1.429 1.429 0 0 1 2.143 15V7.143A1.429 1.429 0 0 1 3.57 5.714H6.43l1.428-2.143h4.286l1.428 2.143h2.858a1.429 1.429 0 0 1 1.428 1.429V15Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 13.571a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Camera };
//# sourceMappingURL=Camera.js.map
